var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyllabusSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "mirror-in-rtl": "true",
    fill: "#8F9BB2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB2",
    d: "M23 2H13V1c0-.55-.45-1-1-1s-1 .45-1 1v1H1c-.55 0-1 .45-1 1s.45 1 1 1h1v8c0 2.21 1.79 4 4 4h5v1.58l-4.71 4.71c-.39.39-.39 1.03 0 1.42.2.19.45.29.71.29s.51-.1.71-.29L11 20.42V23c0 .55.45 1 1 1s1-.45 1-1v-2.58l3.29 3.29c.2.19.45.29.71.29s.51-.1.71-.29c.39-.39.39-1.03 0-1.42L13 17.58V16h5c2.21 0 4-1.79 4-4V4h1c.55 0 1-.45 1-1s-.45-1-1-1zm-3 10c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V4h16v8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB2",
    d: "M16 8H7c-.553 0-1-.448-1-1s.447-1 1-1h9c.553 0 1 .448 1 1s-.447 1-1 1zM12 12H7c-.553 0-1-.448-1-1s.447-1 1-1h5c.553 0 1 .448 1 1s-.447 1-1 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyllabusSvgrepoCom);
export default __webpack_public_path__ + "static/media/syllabus-svgrepo-com.f99415bb3dfdf4dcb61ba009e22c546e.svg";
export { ForwardRef as ReactComponent };